import { defineComponent, ref, h } from 'vue';
import DashboardPlugin from '@uppy/dashboard';
import useUppy from './useUppy.js';
export default defineComponent({
  name: 'Dashboard',
  props: {
    uppy: {
      type: Object,
      required: true
    },
    props: {
      type: Object
    }
  },
  setup(props) {
    const containerRef = ref();
    const pluginRef = ref();
    const propsRef = ref(props.props);
    const onMount = () => {
      const {
        uppy
      } = props;
      const options = {
        id: 'Dashboard',
        inline: true,
        ...props.props,
        target: containerRef.value
      };
      uppy.use(DashboardPlugin, options);
      pluginRef.value = uppy.getPlugin(options.id);
    };
    useUppy(onMount, pluginRef, props.uppy, propsRef);
    return () => h('div', {
      ref: containerRef
    });
  }
});